import React from 'react';
import { DelayedSkeleton } from './delayedSkeleton';

interface RouteFallbackProps {
  /** Delay before the skeleton appears (ms). */
  skeletonDelay?: number;
}

/**
 * The Suspense fallback for lazily-loaded route chunks. It only shows a skeleton
 * for slow loads (see {@link DelayedSkeleton}) so fast navigations don't flash.
 * The top progress bar is driven separately by the chunk-load tracker (see
 * {@link ./lazyWithProgress}), independent of whether this fallback renders.
 */
export const RouteFallback: React.FC<RouteFallbackProps> = ({ skeletonDelay }) => (
  <DelayedSkeleton delay={skeletonDelay} />
);
